import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const csvUrl = contractId => `${environment.apiUrl}/csv/${contractId}`;
const csvExportUrl = contractId => `${environment.apiUrl}/csv/export/${contractId}`;
const csvExportContractsUrl = contractIds => `${environment.apiUrl}/csv/export/contracts/${contractIds}`;
const csvExportFcdUrl = `${environment.apiUrl}/csv/export/fcd`;
const csvExportFcdErrorsUrl = `${environment.apiUrl}/csv/export/fcderrors`;

@Injectable()
export class CsvService {
  constructor(private readonly httpService: HttpService) {}

  importCsv(contractId: string, csvFile: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', csvFile);
    return this.httpService.postFileWithProgress(csvUrl(contractId), formData);
  }

  downloadCsvContract(contractId: number): Observable<any> {
    return this.httpService.post(csvExportUrl(contractId), null);
  }

  downloadCsvContracts(contractIds: number[]): Observable<any> {
    return this.httpService.post(csvExportContractsUrl(contractIds), null);
  }

  downloadCsvFcd(): Observable<any> {
    return this.httpService.post(csvExportFcdUrl, null);
  }

  downloadCsvFcdErrors(): Observable<any> {
    return this.httpService.post(csvExportFcdErrorsUrl, null);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/csv.service.ts